import React,{useState,useEffect,useMemo}from "react";
import { Route, Switch, Redirect} from "react-router-dom";
// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import AuthNavbar from "components/PurchaserFrontend/Navbars/AuthNavbar.js";
import AuthFooter from "components/PurchaserFrontend/Footers/AuthFooter.js";
import {
	Modal,
   ModalHeader,
   ModalBody,
   ModalFooter,
   Button,
} from "reactstrap";
import routes from "routes.js";
import ErrorModal from "components/Core/ErrorModal";
import CardType from "lib/Core/Backend/Controllers/CardType";

const PurchaserAuth = (props) =>
{
	import("assets/plugins/nucleo/css/nucleo.css").then(() => import("assets/scss/argon-dashboard-react.scss"));
	const mainContent = React.useRef(null);
	const {token} =  props;
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [maintainModal,setMainTainModal] = React.useState(false);
	const toggleConfirm = () => setMainTainModal(!maintainModal);
	const cardTypeCtl = useMemo(() => new CardType(token),[token]);

	React.useEffect(() =>
	{
		document.body.classList.add("bg-primary");
		return () =>
		{
			document.body.classList.remove("bg-primary");
		};
	}, []);
	React.useEffect(() =>
	{
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
		if(mainContent.current !== null) mainContent.current.scrollTop = 0;
	}, [mainContent]);

	const hideErrorModal = () => {
		setIsErrorModalOpen(false);
		setErrorMessage('');
	  };
   
	  const handleMaintainModalOff = () =>{
		setMainTainModal(false);
	}
	  const mainatainBackend = () => {
		fetch(`${process.env.REACT_APP_BACKEND_URL}private/auth/maintenance-mode/${true}`)
		
		.then((response) => {
		  
		  toggleConfirm();
		})
		.catch((error) => {
			console.error(`Error: ${error}`);
	})
	
	}
	
	let url;
let maintainCalled = false;
const fetchData = () => {
 url = process.env.REACT_APP_MAINTAIN_URL
    fetch(url)
        .then((response) => {
            if (!response.ok) {
				if(!maintainCalled){
					maintainCalled = true;
					if (response.status === 502 || response.status === 503 || response.status === 504) {
						mainatainBackend();
					}
				}
				
                throw new Error(`HTTP error! Status: ${response.status}`);
				
            }
            return response.json();
        })
        .then((data) => {
			if(data.Status === "OK"){
			}else{
				if (!maintainCalled) { 
					maintainCalled = true;
					mainatainBackend();
				}
			}
            
        })
        .catch((error) => {
            console.error(`Error: ${error}`);
			// if (!maintainCalled) { 
            //     maintainCalled = true; 
            //     mainatainBackend(); 
            // }
        })
       
};

	
	  let pollingInterval;
	
	  useEffect(() => {
		pollingInterval = setInterval(() => {
		  fetchData();
		}, 20000);
	  
		return () => {
		  clearInterval(pollingInterval);
		};
	  }, []);

	
	  
	  



	const getRoutes = (routes) =>
	{
		return routes.map((prop, key) =>
		{
			
			if (prop.layout === "/purchaser-auth")
			{
				return (
					<Route
						path={prop.layout + prop.path}
						component={prop.component}
						key={key}
					/>
				);
			} else
			{
				return null;
			}
		});
	};

	return (
		<>
			{/* <div className="main-content" ref={mainContent}>
				<AuthNavbar/>
				<div className="header bg-gradient-warning py-7 py-lg-8">
					<div className="separator separator-bottom separator-skew zindex-100">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							preserveAspectRatio="none"
							version="1.1"
							viewBox="0 0 2560 100"
							x="0"
							y="0"
						>
							<polygon
								className="fill-primary"
								points="2560 0 2560 100 0 100"
							/>
						</svg>
					</div>
				</div>
				<Container className="mt--8 pb-5">
					<Row className="justify-content-center">
						<Switch>
							{getRoutes(routes)}
							<Redirect from="*" to="/purchaser-auth/login"/>
						</Switch>
					</Row>
				</Container>
			</div>
			<AuthFooter/>
			<ErrorModal isOpen={isErrorModalOpen} toggle={hideErrorModal} errorMessage={errorMessage} />

			<AuthFooter/> */}

			<div className="main-content" ref={mainContent}>
				<Switch>
					{getRoutes(routes)}
					<Redirect from="*" to="/purchaser-auth/login"/>
				</Switch>
			</div>
		</>
	);
};

export default PurchaserAuth;
